import { MessageCircle } from "lucide-react";
import { useSite } from "@/lib/site";
import { waLink } from "@/lib/api";

export const WhatsAppFloat = () => {
  const { data } = useSite();
  const s = data?.settings || {};

  return (
    <a
      data-testid="whatsapp-float-button"
      href={waLink(s.whatsapp)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-whatsapp text-ink flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.35)] hover:scale-110 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-whatsapp/40 animate-ping" style={{ animationDuration: "2.5s" }} />
      <MessageCircle size={24} className="relative" />
    </a>
  );
};

export default WhatsAppFloat;
